var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
let CycleBarNextButton = class CycleBarNextButton extends React.PureComponent {
    get buttonTitle() {
        if (runtime.solidBrowserRuntime.browserDevice.isSmartphone)
            return null;
        return React.createElement("span", { style: { marginLeft: 10, fontSize: 15 } }, this.buttonText);
    }
    get buttonText() {
        const { app } = this.props;
        const { answer } = app;
        if (!answer)
            return;
        if (answer.answerInfo.isHistoricAnswer) {
            return 'Fortsetzen';
        }
        return 'Frage überspringen';
    }
    render() {
        const { app } = this.props;
        return (React.createElement("div", { className: "CycleBarPrevNextButton", onClick: app.cycle.cycleNavigate.handleNextClick },
            this.buttonTitle,
            React.createElement("i", { className: "fas fa-chevron-right", style: { marginRight: 10, marginLeft: 10 } })));
    }
};
CycleBarNextButton = __decorate([
    observer
], CycleBarNextButton);
export { CycleBarNextButton };
